<template>
  <RevInfoBlock class="bg-static-info-low" :icon :title variant="info">
    <CustomerIssues
      v-if="conversation.customerIssues.length"
      :customer-issues="conversation.customerIssues"
    />

    <LabelReturn
      v-if="conversation.labelReturn"
      :label-return="conversation.labelReturn"
    />
  </RevInfoBlock>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconExport } from '@ds/icons/IconExport'
import { IconHeartDiagnostic } from '@ds/icons/IconHeartDiagnostic'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconTools } from '@ds/icons/IconTools'

import type { Conversation } from '~/api/seller-after-sales/types'

import CustomerIssues from '../CustomerIssues/CustomerIssues.vue'
import LabelReturn from '../LabelReturn/LabelReturn.vue'

import translations from './InWarrantyInfoBlock.translations'

const i18n = useI18n()

const { conversation } = defineProps<{ conversation: Conversation }>()

const icon = computed(() => {
  const iconsUsingResolutionType = {
    FACTORY_REPAIR: IconTools,
    SHOP_REPAIR: IconTools,
    REPAIR_REPLACE: IconTools,
    SELLER_REPAIR: IconTools,
    SELLER_REPLACE: IconExport,
    EXPRESS_REPLACE: IconExport,
    REPLACE: IconExport,
    STRAIGHT_REFUND: IconRefund,
    REFUND: IconRefund,
    REMOTE_ASSISTANCE: IconHeartDiagnostic,
    LIVE_CHAT: IconHeartDiagnostic,
    INTERCOM_ASYNC_CHAT: IconHeartDiagnostic,
    INTERCOM_LIVE_CHAT: IconHeartDiagnostic,
  }

  if (!conversation.resolutionType) {
    return IconHeartDiagnostic
  }

  return iconsUsingResolutionType[conversation.resolutionType]
})

const title = computed(() =>
  i18n(translations.title, {
    resolution: conversation.resolutionType,
    count: conversation.customerIssues.length,
    source: '',
  }),
)
</script>
